import Login from "./Login";
import Shell from "./Shell";
import Dashboard from "./Dashboard";
import Server from "./Server";
import Profile from "./Profile";
import Diagnostics from "./Diagnostics";
import Manager from "./Manager";
import Shops from "./Shops";
import Calendar from "./Calendar";
import Payments from "./Payments";
import Communication from "./Communication";
import CommunicationAdmin from "./CommunicationAdmin";
import AutoNotifications from "./AutoNotifications";
import About from "./About";
import VideoTutorial from "./VideoTutorial";
import Marketing from "./Marketing";
import Ecommerce from "./Ecommerce";
import Fidelity from "./Fidelity";
import QCal from "./QCal";

export default {
  Login: Login,
  Shell: Shell,
  Dashboard: Dashboard,
  Server: Server,
  Profile: Profile,
  Diagnostics: Diagnostics,
  Manager: Manager,
  Shops: Shops,
  Calendar: Calendar,
  Payments: Payments,
  Communication: Communication,
  CommunicationAdmin: CommunicationAdmin,
  AutoNotifications: AutoNotifications,
  About: About,
  VideoTutorial: VideoTutorial,
  Marketing: Marketing,
  Ecommerce: Ecommerce,
  Fidelity: Fidelity,
  QCal: QCal
};



// WEBPACK FOOTER //
// ./src/components/backend/components.js